export const getCircleDrawColors = (colors: { polygonEditVertexColor: string; selectedZoneColor: string }) => [
  {
    filter: ['all', ['==', '$type', 'Polygon']],
    id: 'gl-draw-polygon-fill.cold',
    paint: {
      'fill-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'fill-opacity': 0.1
    },
    source: 'mapbox-gl-draw-cold',
    type: 'fill'
  },
  {
    filter: ['any', ['==', '$type', 'LineString'], ['==', '$type', 'Polygon']],
    id: 'gl-draw-lines.cold',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'line-dasharray': ['case', ['==', ['get', 'active'], 'true'], [0.2, 2], [2, 0]],
      'line-width': 2
    },
    source: 'mapbox-gl-draw-cold',
    type: 'line'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
    id: 'gl-draw-point-outer.cold',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 7, 5]
    },
    source: 'mapbox-gl-draw-cold',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
    id: 'gl-draw-point-inner.cold',
    paint: {
      'circle-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 5, 3]
    },
    source: 'mapbox-gl-draw-cold',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
    id: 'gl-draw-vertex-outer.cold',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 7, 5]
    },
    source: 'mapbox-gl-draw-cold',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
    id: 'gl-draw-vertex-inner.cold',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 5, 3]
    },
    source: 'mapbox-gl-draw-cold',
    type: 'circle'
  },
  {
    filter: ['all', ['==', 'meta', 'midpoint']],
    id: 'gl-draw-midpoint.cold',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    source: 'mapbox-gl-draw-cold',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Polygon']],
    id: 'gl-draw-polygon-fill.hot',
    paint: {
      'fill-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'fill-opacity': 0.1
    },
    source: 'mapbox-gl-draw-hot',
    type: 'fill'
  },
  {
    filter: ['any', ['==', '$type', 'LineString'], ['==', '$type', 'Polygon']],
    id: 'gl-draw-lines.hot',
    layout: {
      'line-cap': 'round',
      'line-join': 'round'
    },
    paint: {
      'line-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'line-dasharray': ['case', ['==', ['get', 'active'], 'true'], [0.2, 2], [2, 0]],
      'line-width': 2
    },
    source: 'mapbox-gl-draw-hot',
    type: 'line'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
    id: 'gl-draw-point-outer.hot',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 7, 5]
    },
    source: 'mapbox-gl-draw-hot',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
    id: 'gl-draw-point-inner.hot',
    paint: {
      'circle-color': ['case', ['==', ['get', 'active'], 'true'], colors.selectedZoneColor, colors.selectedZoneColor],
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 5, 3]
    },
    source: 'mapbox-gl-draw-hot',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
    id: 'gl-draw-vertex-outer.hot',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 7, 5]
    },
    source: 'mapbox-gl-draw-hot',
    type: 'circle'
  },
  {
    filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'vertex'], ['!=', 'mode', 'simple_select']],
    id: 'gl-draw-vertex-inner.hot',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': ['case', ['==', ['get', 'active'], 'true'], 5, 3]
    },
    source: 'mapbox-gl-draw-hot',
    type: 'circle'
  },
  {
    filter: ['all', ['==', 'meta', 'midpoint']],
    id: 'gl-draw-midpoint.hot',
    paint: {
      'circle-color': colors.polygonEditVertexColor,
      'circle-radius': 3
    },
    source: 'mapbox-gl-draw-hot',
    type: 'circle'
  }
];
